import * as S from './styles'

export const Centered = ({ children }: { children: React.ReactNode }) => {
  return <S.Wrapper>{children}</S.Wrapper>
}
